// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentAlternateCardId {
    static getAttributeTypeMap() {
        return ExtEnrollmentAlternateCardId.attributeTypeMap;
    }
}
ExtEnrollmentAlternateCardId.discriminator = undefined;
ExtEnrollmentAlternateCardId.additionalProperties = false;
ExtEnrollmentAlternateCardId.attributeTypeMap = [
    {
        "name": "alternateCardNumber",
        "baseName": "alternateCardNumber",
        "type": "string"
    },
    {
        "name": "cardAlternateIdType",
        "baseName": "cardAlternateIdType",
        "type": "AlternateCardType"
    },
];
//# sourceMappingURL=extEnrollmentAlternateCardId.js.map